import enloc from 'element-ui/lib/locale/lang/en'

export default {
  main:{
    message:"message",
    display:"display"
  },
  ...enloc
};


// WEBPACK FOOTER //
// ./src/lang/en.js